import { fcEach, datasetFactory } from '../lib/lib';
let TRUE_STRING = 'true',
  ONE_STRING = '1',
  /**
    * Seggregates the original data to data and vline.
    * @param {Object} data  Original data used for seggregation.
    * @return {Object}  JSON data to be used further by the child components, e.g. dataSet.
   */
  _dataSegregator = (data) => {
    var dataOnlyArr = [];

    fcEach(data, function (datum) {
      if (!(datum.vline === TRUE_STRING || datum.vline === true || datum.vline === 1 ||
                  datum.vline === ONE_STRING)) {
        dataOnlyArr.push(datum);
      }
    });
    return {
      catData: [],
      data: dataOnlyArr
    };
  };
/**
 * function to  create dataset.
 * assign dataset to vCanvas.
 * @param {Object} chart chart API
 **/
export default function (chart) {
  let dataObj = chart.getFromEnv('dataSource'),
    dataset = dataObj.dataset,
    data = dataObj.data || (dataset && dataset[0].data),
    DSClass,
    datasetJSON;

  datasetJSON = _dataSegregator(data);

  if (!(data && data.length !== 0)) {
    chart.setChartMessage();
    return;
  }
  DSClass = chart.getDSdef();
  datasetFactory(chart, DSClass, 'dataset', 1, [datasetJSON]);
}
